module.exports = __webpack_public_path__ + "img/logo-default.704de484.png";